<template>
    <section 
        class="text-center position-relative d-flex align-items-center justify-content-center" 
        style="min-height: 380px; background-size: cover; background-position: center;"
        :style="`background-image: url('/images/services/${service.img}')`">
        <!-- New Gradient Overlay natively matching Weight Loss dark gradient -->
        <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: linear-gradient(135deg, rgba(0, 19, 38, 0.85) 0%, rgba(4, 92, 184, 0.75) 50%, rgba(0, 180, 255, 0.65) 100%); z-index: 0;"></div>
        
        <div class="container position-relative z-index-1" style="z-index: 1;">
            <div class="row">
                <div class="col-lg-12 col-12">
                    <h1 v-if="language === LANGUAGES.PT_BR" class="text-white" style="font-family: 'Montserrat', sans-serif; font-weight: 700; text-shadow: 0 2px 4px rgba(0,0,0,0.5);">{{ service.labelPtBR }}</h1>
                    <h1 v-else-if="language === LANGUAGES.ES" class="text-white" style="font-family: 'Montserrat', sans-serif; font-weight: 700; text-shadow: 0 2px 4px rgba(0,0,0,0.5);">{{ service.labelEs }}</h1>
                    <h1 v-else class="text-white" style="font-family: 'Montserrat', sans-serif; font-weight: 700; text-shadow: 0 2px 4px rgba(0,0,0,0.5);">{{ service.labelEn }}</h1>
                </div>
            </div>
        </div>
    </section>
    <section class="wl-section" style="background: var(--wl-bg);">
        <div class="container">
            <div class="row">
                <div class="col-12" >
                    <div class="wl-card p-4 p-md-5" style="margin-top: -60px; position: relative; z-index: 2; font-family: 'Inter', sans-serif; font-size: 16px; color: var(--wl-text); line-height: 1.8;">
                        <component :is="service.component" :language="language"></component>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>

import { useRoute } from 'vue-router'
import { watch, ref, computed } from "vue";
import { servicesContent } from './ServicesDetails/ServicesContent'
import { useI18n } from 'vue-i18n';
import { markRaw } from 'vue';
import { LANGUAGES } from '@/common/constants';

export default({
    setup() {
        const { locale } = useI18n();
        let service = ref({})
        const route = useRoute()

        const initData = () => {
            const serviceParams = route.params.service

            function retornaServiceContent (value){
                if (value.nameParams == serviceParams)
                    return value;
            }
            let resultService = servicesContent.filter(retornaServiceContent)
            service.value = markRaw(resultService[0])
        }
        initData()

        watch(
            () => route.params,
            () => {
                initData()
            }
        )

        const language = computed(() => {
            return locale.value;
        });

        return {
            service,
            language,
            LANGUAGES
        }
    }
})
</script>
